import _ from "lodash";
import React, { useRef } from "react";
import classes from "./ColorTray.scss";
import { colors } from "Constants";
import ColorDrop from "UIComponents/ColorDrop";
const ColorTray = React.memo(props => {
  const { onBlur, onColorSelected, selectedColor, options } = props;
  const node = useRef();

  return (
    <div ref={node} className={classes.colorTray}>
      {_.map(options, color => (
        <div
          key={color}
          className={classes.colorDropContainer}
          onClick={() => {
            onColorSelected(color);
          }}
          tabIndex={0}
          onKeyDown={e =>
            (e.key === " " || e.key === "Enter") && onColorSelected(color)
          }
        >
          <ColorDrop
            size={24}
            isSelected={color === selectedColor}
            color={color}
          />
        </div>
      ))}
    </div>
  );
});

ColorTray.defaultProps = {
  options: [
    colors.blue400,
    colors.salmon60,
    colors.yellow500,
    colors.violet500,
    colors.teal200,
    colors.pink200,
    colors.blue700,
    colors.neutral400,
    colors.blueTwo,
    "", //No Colour
  ],
};
ColorTray.displayName = "ColorTray";
export default ColorTray;
